import { Alert, Card, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/context/AuthContext';
import { canManageDoohScreens } from '@/layouts/navigation';
import { ScreensTable } from '../components/ScreensTable';
import { DoohFlowHint } from '../components/DoohFlowHint';
import { useDoohScreens } from '../hooks/useDoohScreens';

/**
 * Pantallas DOOH (TG-59, `/dooh/pantallas`): listado con estado/último contacto
 * (semáforo verde/rojo/amarillo como el NOC) y acceso al detalle/config.
 * Solo SUPER_ADMIN / SOPORTE_N3.
 */
export function ScreensPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const screens = useDoohScreens();

  const canManage = canManageDoohScreens(user?.role);

  return (
    <div className="dooh-page">
      <div className="dooh-page__header">
        <div>
          <Typography.Title level={3} style={{ margin: 0 }}>
            Pantallas
          </Typography.Title>
          <Typography.Text type="secondary">
            Pantallas de la red: su estado de conexión y su configuración.
          </Typography.Text>
        </div>
      </div>

      <DoohFlowHint current="screens" />

      {!canManage && (
        <Alert
          type="warning"
          showIcon
          message="Solo lectura"
          description="Tu rol no permite configurar pantallas. Se requiere SuperAdmin o Soporte N3."
        />
      )}

      <Alert
        type="info"
        showIcon
        message="Las pantallas se registran automáticamente"
        description="Las pantallas se registran automáticamente la primera vez que se conectan. Configura nombre, ubicación y resolución desde el detalle."
      />

      <Card>
        <ScreensTable
          screens={screens.data}
          loading={screens.loading}
          error={screens.error}
          onRetry={screens.refresh}
          onSelect={(screen) => navigate(`/dooh/pantallas/${encodeURIComponent(screen.id)}`)}
        />
      </Card>
    </div>
  );
}
